(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mediaclip"] && !Shopify.designMode) return;
  try {
    (() => {
    const API_CONFIG = {
      // Set window.cmApiUrl via Liquid when connecting to the real API
      get baseUrl() {
        return window.cmApiUrl || '';
      },
      endpoint: '/customer/custom-projects',
    };

    const projectDataCache = {};

    /**
     * Fetches project details for the given MediaClip project IDs.
     * Returns a map of projectId -> { projectName, details, orderNumber }.
     */
    async function getProjectData(projectIds) {
      const uniqueIds = [...new Set(projectIds.filter(Boolean))];
      if (!uniqueIds.length) return {};

      const uncachedIds = uniqueIds.filter((id) => !(id in projectDataCache));
      if (!uncachedIds.length) {
        return pickCachedProjectData(uniqueIds);
      }

      let fetchedData = {};

      fetchedData = await fetchProjectDataFromApi(uncachedIds);

      Object.assign(projectDataCache, fetchedData);
      return pickCachedProjectData(uniqueIds);
    }

    async function fetchProjectDataFromApi(projectIds) {
      const response = await fetch(`${API_CONFIG.baseUrl}${API_CONFIG.endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${window.customer?.accessToken ?? ''}`,
        },
        body: JSON.stringify({ projectIds }),
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch project data: ${response.status}`);
      }

      const payload = await response.json();
      return normalizeProjectDataResponse(payload);
    }

    function normalizeProjectDataResponse(payload) {
      if (Array.isArray(payload)) {
        return Object.fromEntries(
          payload
            .filter((item) => item?.projectId)
            .map((item) => [item.projectId, {
              projectName: item.projectName,
              details: item.details,
              orderNumber: item.orderNumber,
            }])
        );
      }

      if (payload?.data && typeof payload.data === 'object') {
        return payload.data;
      }

      return payload ?? {};
    }

    function pickCachedProjectData(projectIds) {
      return Object.fromEntries(
        projectIds
          .filter((id) => projectDataCache[id])
          .map((id) => [id, projectDataCache[id]])
      );
    }

    function buildProjectDetailsContent(data) {
      const fragment = document.createDocumentFragment();

      const { projectName, details, orderNumber } = data;

      if (projectName != null && projectName !== '') {
        const name = document.createElement('div');
        name.className = 'mediaclip-project-name';
        name.textContent = projectName;
        fragment.appendChild(name);
      }

      if (details != null && details !== '') {
        const detailsElement = document.createElement('div');
        detailsElement.className = 'mediaclip-project-details-text';
        detailsElement.textContent = details;
        fragment.appendChild(detailsElement);
      }

      if (orderNumber != null && orderNumber !== '') {
        const order = document.createElement('div');
        order.className = 'mediaclip-project-order';
        order.textContent = `Order #${orderNumber}`;
        fragment.appendChild(order);
      }

      return fragment;
    }

    async function enhanceMediaclipTable(table) {
      const theadRow = table.querySelector('thead tr');
      if (theadRow && !theadRow.querySelector('.mediaclip-project-details-th')) {
        const th = document.createElement('th');
        th.className = 'mediaclip-project-details-th';
        th.textContent = 'Project Details';
        theadRow.insertBefore(th, theadRow.firstChild);
      }

      const rowsToEnhance = [...table.querySelectorAll('tbody tr')].filter(
        (row) => !row.querySelector('.mediaclip-project-details')
      );
      if (!rowsToEnhance.length) return;

      // Claim each row synchronously by inserting its (empty) details cell now, before the
      // async fetch. The observer can re-run enhanceMediaclipTable while the fetch is in
      // flight; because these rows already have a `.mediaclip-project-details` cell, that
      // pass filters them out — so a row can never receive two cells.
      const cells = rowsToEnhance.map((row) => {
        const td = document.createElement('td');
        td.className = 'mediaclip-project-details';
        row.insertBefore(td, row.firstChild);
        return td;
      });

      const projectIds = rowsToEnhance.map((row) => row.dataset.mcProjectId);
      let projectData = {};

      try {
        projectData = await getProjectData(projectIds);
      } catch (error) {
        console.error('[Mediaclip] Failed to load project data:', error);
      }

      rowsToEnhance.forEach((row, i) => {
        const projectId = row.dataset.mcProjectId;
        const data = projectId ? projectData[projectId] : null;
        if (data) {
          cells[i].appendChild(buildProjectDetailsContent(data));
        }
      });
    }

    function setupTableObserver(table) {
      enhanceMediaclipTable(table);

      const tableObserver = new MutationObserver(() => {
        enhanceMediaclipTable(table);
      });
      tableObserver.observe(table, { childList: true, subtree: true });
    }

    function init() {
      const table = document.querySelector('.mediaclip-projects-table');
      if (table) {
        if (table.dataset.mediaclipEnhanced !== 'true') {
          table.dataset.mediaclipEnhanced = 'true';
          setupTableObserver(table);
        }
        return;
      }

      const observer = new MutationObserver(() => {
        const foundTable = document.querySelector('.mediaclip-projects-table');
        if (foundTable && foundTable.dataset.mediaclipEnhanced !== 'true') {
          foundTable.dataset.mediaclipEnhanced = 'true';
          setupTableObserver(foundTable);
          observer.disconnect();
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const readMoreButtons = document.querySelectorAll('[data-read-more-toggle]');
    
    readMoreButtons.forEach(button => {
      button.addEventListener('click', function() {
        const wrapper = this.closest('.text-block-wrapper');
        const content = wrapper.querySelector('[data-read-more-content]');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        
        // Toggle expanded state
        this.setAttribute('aria-expanded', !isExpanded);
        content.classList.toggle('is-expanded');
        
        // Smooth scroll to top of content when collapsing
        if (isExpanded) {
          const contentTop = content.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({
            top: contentTop,
            behavior: 'smooth'
          });
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-swatches"] && !Shopify.designMode) return;
  try {
    (() => {
    function setupSwatchNavigation() {
      document.querySelectorAll('swatches-variant-picker-component input[type="radio"][data-product-url]').forEach((swatchInput) => {
  
        if (swatchInput.dataset.navigationSetup === 'true') return;
        
        swatchInput.dataset.navigationSetup = 'true';
        const label = swatchInput.closest('label');
        if (label) {
          label.addEventListener('click', (event) => {
            if (event.target.tagName === 'BUTTON' || event.target.closest('button')) {
              return;
            }
            
            const productUrl = swatchInput.dataset.productUrl;
            
            if (productUrl) {
              setTimeout(() => {
                const shouldOpenInNewTab = event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1;
                
                if (shouldOpenInNewTab) {
                  window.open(productUrl, '_blank');
                } else {
                  window.location.href = productUrl;
                }
              }, 50);
            }
          });
        }
      });
    }
    
    function enhanceSwatches() {
      document.querySelectorAll('swatches-variant-picker-component').forEach((swatchesPicker) => {
        if (swatchesPicker.dataset.variantEnhanced === 'true') return;
        
        const productCard = swatchesPicker.closest('product-card');
        if (!productCard) return;
        
        const listItem = productCard.closest('li[data-variant-id]');
        if (!listItem) return;
        
        const variantId = parseInt(listItem.dataset.variantId, 10);
        if (!variantId) return;
        
        const variantInput = swatchesPicker.querySelector(`input[data-variant-id="${variantId}"]`);
        if (!variantInput) return;
        
        const swatchItem = variantInput.closest('li.variant-option__swatch');
        if (!swatchItem) return;
        
        const fieldset = swatchItem.closest('fieldset');
        if (!fieldset) return;
        
        const overflowList = fieldset.querySelector('overflow-list');
        
        if (overflowList) {
          const checkOverflowList = () => {
            const list = overflowList.querySelector('ul');
            if (list && swatchItem.parentElement) { 
              list.insertBefore(swatchItem, list.firstChild);
              swatchesPicker.dataset.variantEnhanced = 'true';
            } else {
              setTimeout(checkOverflowList, 50);
            }
          };
          checkOverflowList();
        } else {
          if (swatchItem.parentElement === fieldset) {
            fieldset.insertBefore(swatchItem, fieldset.firstChild);
          }
          swatchesPicker.dataset.variantEnhanced = 'true';
        }
        
        // Set the input as checked
        variantInput.checked = true;
        
        const mediaId = variantInput.dataset.optionMediaId;
        
        if (swatchesPicker && swatchesPicker.updateSelectedOption) {
          try {
            swatchesPicker.updateSelectedOption(variantInput);
          } catch (e) {
            console.warn('Could not update selected option:', e);
          }
        }
        
        if (mediaId && productCard) {
          if (productCard.previewVariant && typeof productCard.previewVariant === 'function') {
            productCard.previewVariant(mediaId);
          }
        }

        const changeEvent = new Event('change', { bubbles: true, cancelable: true });
        Object.defineProperty(changeEvent, 'target', {
          value: variantInput,
          enumerable: true
        });
        variantInput.dispatchEvent(changeEvent);
        
        setTimeout(() => {
          if (productCard && productCard.variantPicker && productCard.variantPicker.selectedOption) {
            const selectedMediaId = productCard.variantPicker.selectedOption.dataset.optionMediaId;
            
            if (selectedMediaId && selectedMediaId === mediaId) {
              const cardGallery = productCard.querySelector('[ref="cardGallery"]') || 
                                 productCard.querySelector('.card-gallery');
              
              if (cardGallery) {
                const slideshow = cardGallery.querySelector('slideshow-component');
                
                if (slideshow) {
                  let slides = [];
                  if (slideshow.refs && slideshow.refs.slides) {
                    slides = slideshow.refs.slides;
                  } else {
                    slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
                  }
                  
                  if (slides.length > 0) {
                    for (const slide of slides) {
                      const slideMediaId = slide.getAttribute('slide-id');
                      const isVariantImage = slide.hasAttribute('variant-image');
                      
                      if (isVariantImage && slideMediaId) {
                        slide.hidden = slideMediaId !== mediaId;
                        slide.setAttribute('aria-hidden', slideMediaId !== mediaId ? 'true' : 'false');
                      }
                    }
                    
                    if (slideshow.select && typeof slideshow.select === 'function') {
                      const targetSlide = slides.find(slide => {
                        const slideMediaId = slide.getAttribute('slide-id');
                        return slideMediaId === mediaId && !slide.hidden;
                      });
                      
                      if (targetSlide) {
                        slideshow.select({ id: mediaId }, undefined, { animate: false });
                      }
                    }
                  }
                }
              }
            }
          }
        }, 200);
      });
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        enhanceSwatches();
        setupSwatchNavigation();
      });
    } else {
      enhanceSwatches();
      setupSwatchNavigation();
    }
    
    setTimeout(() => {
      enhanceSwatches();
      setupSwatchNavigation();
    }, 100);
  })();
  } catch(e) { console.error(e); }
})();

})();
